/*
Author : Mateo Mirindi
Company : Numerik
Fichier : src/pages/finances/currencies/Edit.js
Created On : 14 May 2022 18:42:13
*/

import React, { useContext, useState, useEffect } from "react"
import { Card, Col, Form, Row } from "react-bootstrap"
import { Link, useParams } from "react-router-dom"
import {
  BreadCrumb,
  Button,
  ButtonList,
  FormGroup,
  Switch,
} from "../../../components/utilities"
import { AppContext } from "../../../context/AppContext"
import {
  EDIT_CURRENCY,
  FINANCES_CURRENCIES,
  SHOW_CURRENCY,
} from "../../../routes"
import { EDIT_CURRENCY_API, UPDATE_CURRENCY } from "../../../routes/api"
import { useMakeRequest } from "../../../services/httpClient"
import { notify } from "../../../services/Notification"
import { notifyError, setValidationErrors } from "../../../services/Validation"

const Edit = () => {
  const { id } = useParams()
  const [currency, setCurrency] = useState("")
  const [name, setName] = useState("")
  const [symbol, setSymbol] = useState("")
  const [isActive, setIsActive] = useState(false)
  const [errors, setErrors] = useState([])
  const { isLoading } = useContext(AppContext)
  const { makeRequest } = useMakeRequest()

  useEffect(() => {
    fetchData()
  }, [])

  function fetchData(url = null) {
    makeRequest({
      route: EDIT_CURRENCY_API.replace(":id", id),
      onSuccess: onFetchSuccess,
      onError: onFetchError,
    })
  }

  function onFetchSuccess(response) {
    if (response.status === 200) {
      let currency = response.data
      setCurrency(currency.currency)
      setName(currency.name)
      setSymbol(currency.symbol)
      setIsActive(currency.is_active)
    }
  }

  function onFetchError(error) {
    notifyError(error)
  }

  function onSubmit(e) {
    e.preventDefault()
    makeRequest({
      method: "post",
      route: UPDATE_CURRENCY.replace(":id", id),
      data: {
        currency: currency,
        name: name,
        symbol: symbol,
        is_active: isActive,
      },
      onSuccess: onSuccess,
      onError: onError,
    })
  }

  function onSuccess(response) {
    if (response.status === 200) {
      notify({ message: response.data.message })
      resetData()
    }
  }

  function resetData() {
    setErrors([])
  }

  function onError(error) {
    setValidationErrors(setErrors, error)
  }

  const breadcrumb = [
    {
      caption: "Finances",
      active: true,
    },
    {
      caption: "Dévises",
      link: FINANCES_CURRENCIES,
    },
    {
      link: SHOW_CURRENCY.replace(":id", id),
      caption: "#" + id,
    },
    {
      link: EDIT_CURRENCY.replace(":id", id),
      caption: "Modifier la devise",
      active: true,
    },
  ]

  return (
    <div>
      <BreadCrumb items={breadcrumb} />
      <Row>
        <Col md={6}>
          <Form method="post" onSubmit={onSubmit}>
            <Card>
              <Card.Header>Modifier - #{id}</Card.Header>
              <Card.Body>
                <FormGroup
                  label="Devise"
                  disabled={isLoading}
                  value={currency}
                  onChange={setCurrency}
                  error={errors.currency}
                />

                <Row>
                  <Col md={6}>
                    <FormGroup
                      label="Nom"
                      disabled={isLoading}
                      value={name}
                      onChange={setName}
                      error={errors.name}
                    />
                  </Col>
                  <Col md={6}>
                    <FormGroup
                      label="Symbole"
                      disabled={isLoading}
                      value={symbol}
                      onChange={setSymbol}
                      error={errors.symbol}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Switch
                      label="Activer la devise"
                      id="activate"
                      disabled={isLoading}
                      value={isActive}
                      checked={isActive}
                      onChange={setIsActive}
                      error={errors.is_acitve}
                    />
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <ButtonList>
                  <Link
                    className="btn btn-light"
                    to={SHOW_CURRENCY.replace(":id", id)}
                    disabled={isLoading}
                  >
                    Annuler
                  </Link>
                  <Button
                    type="submit"
                    variant="info"
                    disabled={isLoading}
                    isLoading={isLoading}
                  >
                    Mettre à jour
                  </Button>
                </ButtonList>
              </Card.Footer>
            </Card>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default Edit
